import { gql, useMutation } from '@apollo/client'
import { isEmpty } from 'ramda'
import { useNavigate, useParams } from '@reach/router'

import { useAlertModal } from '../../../../utils/routes/modals/modalsActions'
import { useExecutionDynamicServiceOrders } from '../_form/ExecutionDynamicServiceOrdersHandler'
import { useNotification } from '@btime/react-messager'
import { useDynamicServiceOrders } from '../_load/DynamicServiceOrdersLoader'
import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { useSessionChecker, useSessionState } from '@btime/react-session'
import { cleanRequest } from './cleanRequest'
import { useImperativeComponents } from '../../../../containers/dynamic/form/replies/context/ImperativeComponentsContext'
import { indexOfFirstInvalidReply } from '../../../serviceOrders/executionV2/_helpers/saveServiceOrder'

const MUTATION = gql`
  mutation UpsertServiceOrder($input: ServiceOrderInput, $token: String) {
    upsertServiceOrder(input: $input, token: $token) {
      id
    }
  }
`

export const useSaveDynamicServiceOrders = () => {
  useSessionChecker()
  const { redirectToExecution, configuration, place, asset, ...dynamicServiceOrder } = useDynamicServiceOrders()
  const [request, state] = useMutation(MUTATION, { client: serviceOrdersClient, fetchPolicy: 'no-cache' })
  const executionForm = useExecutionDynamicServiceOrders()

  const { getRepliesValue, setFocus } = useImperativeComponents()

  const { shareCode } = useParams()
  const { user } = useSessionState()
  const openAlert = useAlertModal()
  const notify = useNotification()
  const navigate = useNavigate()

  const assetId = asset?.id

  const placeId = place?.id ?? executionForm?.place?.id
  const shouldBeRedirectToExecution = redirectToExecution

  const hasConfiguration = !isEmpty(configuration)
  const hasTitleMessage = !isEmpty(configuration?.titleMessage)
  const hasBodyMessage = !isEmpty(configuration?.bodyMessage)

  const titleMessage =
    hasConfiguration && hasTitleMessage ? configuration?.titleMessage : 'Atividade respondida com sucesso!'
  const bodyMessage = hasConfiguration && hasBodyMessage ? configuration?.bodyMessage : 'Obrigado pelas respostas.'

  const handleRequest = () => {
    const replies = getRepliesValue()
    const firstInvalidReplyIndex = indexOfFirstInvalidReply(replies)

    if (!placeId && !assetId) {
      return openAlert('Local não encontrado', 'Verifique se o local foi definido.', {
        icon: 'BsInfoCircle'
      })
    }
    if (firstInvalidReplyIndex) {
      setFocus(firstInvalidReplyIndex?.questionId)
      return openAlert('Respostas obrigatórias faltando', 'Verifique as perguntas com as tags vermelhas.', {
        icon: 'BsInfoCircle'
      })
    }

    const input = cleanRequest(replies, user, placeId, assetId, dynamicServiceOrder)
    const token = user?.id ? null : shareCode

    return request({ variables: { input, token } })
      .then(resp => {
        if (!resp.errors) {
          if (shouldBeRedirectToExecution) {
            notify.success({
              title: titleMessage,
              message: bodyMessage
            })

            navigate(`/dynamic-service-orders/${shareCode}/execution`)
          } else {
            navigate(`/dynamic-service-orders/successfully-executed/${shareCode}`)
          }
        }
      })
      .catch(() =>
        openAlert('Não foi possível enviar', 'Ocorreu um erro ao enviar as respostas. Tente novamente.', {
          icon: 'BsInfoCircle'
        })
      )
  }

  return [handleRequest, state]
}
